import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import PageAPI from "../../api/PageAPI";
import { useQuery } from "@tanstack/react-query";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { View } from "../../../types/PageInterfaces";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";

// Fetching a Views SubViews
// Used for Sharing Records Related Records,
// we need the SubView's module api name, and view filters
const useSubViews = ({
  pageID,
  parentViewID,
  disabled = false,
}: {
  pageID: string | undefined;
  parentViewID: string | undefined;
  disabled?: boolean;
}) => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const subViews = useQuery({
    queryKey: ["subViews", parentViewID],
    queryFn: () =>
      PageAPI.getSubviews(workspaceID, pageID, parentViewID).then(
        (data) => data.data.data || null
      ),
    enabled: !!parentViewID && queriesEnabled && !disabled,
  });

  return {
    subviews: (subViews.data?.subViews as View[]) || ([] as View[]),
    subviewsLoading: !queriesEnabled || disabled || subViews.isLoading,
    subviewError: subViews.error ? getErrorMessage(subViews.error) : null,
  };
};

export default useSubViews;
